import { NavLink } from 'react-router-dom';

import Typography from '@anwb/poncho/components/typography';

import { PanelHeaderWrapper } from './panel-edit-header.styled';

type PanelEditHeaderProps = {
	title: string;
	onClick: () => void;
	getStepPath: (step: string) => string;
	stepToEdit: string;
	dataTest: string;
};

export const PanelEditHeader = ({
	title,
	onClick,
	getStepPath,
	stepToEdit,
	dataTest,
}: PanelEditHeaderProps) => (
	<PanelHeaderWrapper>
		<Typography variant="component-title">{title}</Typography>
		<NavLink to={getStepPath(stepToEdit)} onClick={onClick} data-test={dataTest}>
			<Typography as="span" variant="link-text">
				wijzigen
			</Typography>
		</NavLink>
	</PanelHeaderWrapper>
);
